module.exports = "/shifts/components/filters/positionsOptions-24c5a2.html";